module.exports = __webpack_public_path__ + "static/media/Completed.aa40bd6a.svg";